import PropTypes from 'prop-types'

export const drawerType = PropTypes.shape({
  site: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  }),
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }),
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  receiptData: PropTypes.shape({
    expectedAmount: PropTypes.shape({
      bookings: PropTypes.shape({
        cash: PropTypes.number,
        card: PropTypes.number
      }),
      sales: PropTypes.shape({
        cash: PropTypes.number,
        card: PropTypes.number
      })
    }),
    actualAmount: PropTypes.shape({
      cash: PropTypes.number,
      card: PropTypes.number
    }),
    ticketsByStatus: PropTypes.shape({
      confirmed: PropTypes.number,
      cancelled: PropTypes.number
    })
  })
})
